import "./index.css"

import React, { useEffect } from "react"
import toast, { Toaster } from "react-hot-toast"

import close from "../../assets/common/close.svg"
import error from "../../assets/common/error.svg"
import warning from "../../assets/common/info.svg"
import tick from "../../assets/common/tick.svg"

const notify = (status, message, timeout) => {
    let container, textColor, svgImage
    if (status === "SUCCESS") {
        container = "bg-greenlight toast-success-container"
        svgImage = tick
        textColor = "text-green"
    } else if (status === "ERROR") {
        container = "bg-lightred toast-error-container"
        svgImage = error
        textColor = "text-red"
    }else if (status === "WARNING") {
        container = "bg-greenyellow toast-warning-container"
        svgImage = warning
        textColor = "text-black"
    }
   
    toast.custom(
        (t) => (
            <div
                className={ `flex p-1 h-12 w-auto h-auto rounded-t ${container}` }
                style={ { transition: "opacity 100ms ease-in-out" } }
            >
                <div className="ml-4 mt-2 h-7 w-7">
                    <img src={ svgImage } alt={ status } />
                </div>
                <div className={ `mr-4 mt-2 toast-msg ${textColor}` }>
                    { /* Beautify the toast messages */ }
                    { message && Array.isArray(message) && (
                        <>
                            { status === "ERROR" && (<div>Error occured while processing</div>) }
                            <ul className="list-disc pl-3">
                                { message.map(msg=>(<li>{ msg }</li>)) }
                            </ul>
                        </>
                        
                    ) }
                    { message && (typeof message === "string" || message instanceof String ) && message }
                </div>
                <button
                    onClick={ () => toast.remove(t.id) }
                    className="toast-close-btn mt-3 h-4 w-4 mr-3"
                >
                    <img src={ close } alt="close" />
                </button>
            </div>
        ),
        {
            duration: timeout || 3000
        }
    )
   
}

export default function ToastNotification() {
    useEffect(()=>{
        toast.remove()
    },[])
    return <Toaster position="top-right" />
}

export { notify }
